import script from "./xt_imgcard.vue?vue&type=script&setup=true&lang=js"
export * from "./xt_imgcard.vue?vue&type=script&setup=true&lang=js"

import "./xt_imgcard.vue?vue&type=style&index=0&id=70e2fee3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e2fee3"]])

export default __exports__